import { render, staticRenderFns } from "./SenderText.vue?vue&type=template&id=34578e4c&scoped=true&lang=pug"
import script from "./SenderText.vue?vue&type=script&lang=js"
export * from "./SenderText.vue?vue&type=script&lang=js"
import style0 from "./SenderText.vue?vue&type=style&index=0&id=34578e4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34578e4c",
  null
  
)

export default component.exports